import { LOADERS } from "app/pages/activation/components/HomeWithData/Alerts/constants";
import { Item, LoadingItem, NoProjectItem } from "app/pages/activation/components/HomeWithData/Alerts/Item";
import { useHomeContext } from "app/pages/activation/context/Home/HomeContext";
import type { PriorityAlertItem } from "app/pages/activation/types/api";

type ItemsSchema = {
    isLoading: boolean;
    hasAlerts: boolean;
    onClickCreateProject: () => void;
    onItemClick: (alert: PriorityAlertItem) => void;
    alerts?: PriorityAlertItem[];
};

export const Items = ({ isLoading, onClickCreateProject, onItemClick, alerts }: ItemsSchema) => {
    const { isImagesLoading, images } = useHomeContext();

    if (isLoading || isImagesLoading) {
        return (
            <>
                {LOADERS.map((item, i) => (
                    <LoadingItem key={item + i} />
                ))}
            </>
        );
    }

    if (!alerts) {
        return (
            <>
                <NoProjectItem
                    type="keywords"
                    onClickCreateProject={onClickCreateProject}
                />
                <NoProjectItem
                    type="website"
                    onClickCreateProject={onClickCreateProject}
                />
            </>
        );
    }

    return (
        <>
            {alerts?.map((alert) => (
                <Item
                    key={alert.id}
                    alert={alert}
                    domainIcon={images[alert.domain] ?? ""}
                    onClick={onItemClick}
                />
            ))}
        </>
    );
};
